import { Trans } from "@coworker/locales";
import BasicWidget from "@coworker/components/src/components/BasicWidget";
import { useInputPopup } from "../../InputPopup";
import { pqHowList } from "@coworker/enums/pqHowList";
import MagnifyingGlass24 from "../../../assets/svg/icon-search-24.svg?react";
import { pqHowOptions } from "@coworker/enums/pqHowOptions";

export default function TaskFormRadiobuttons({
  value,
  onChange,
  list = pqHowList,
  icon = <MagnifyingGlass24 width={22} height={22} color={"grey900"} />,
  testId = "radiobuttonsWidget",
  additionalSubTitle = <></>,
}) {
  const { getInput } = useInputPopup();
  const handler = async () => {
    const data = await getInput("radiobuttons", {
      value,
      title: <Trans>howDidYouDiscoverString</Trans>,
      list,
    });
    if (data) onChange(data);
  };
  const [type] = value;
  const current = list.find((item) => item.value === type);
  const choiceText = current && <Trans>{current.translationKey}</Trans>;
  const content =
    (current && current?.value === pqHowOptions.OTHER && value[1]) ||
    choiceText;

  return (
    <BasicWidget
      tabIndex={0}
      onClick={handler}
      title={<Trans>howDidYouDiscoverString</Trans>}
      text={content}
      testId={testId}
      icon={icon}
      additionalSubTitle={!type ? additionalSubTitle : <></>}
    />
  );
}
